<template>
  <RouterView />
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref } from 'vue'
import { connectNotificationStream } from './services/notificationStream'

const stream = ref<EventSource | null>(null)

onMounted(() => {
  stream.value = connectNotificationStream()
})

onBeforeUnmount(() => {
  stream.value?.close()
})
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
